import $ from "jquery";

$(".workshop__list-examples .workshop__list-examples__list").each(function () {
  const $slider = $(this);
  const itemsCount = $slider.find(".examples__list-item").length;

  // если элементов мало — slick не нужен
  if (itemsCount <= 8) return;

  // защита от двойной инициализации
  if ($slider.hasClass("slick-initialized")) return;

  $slider.slick({
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8.5,
    slidesToScroll: 1,
    arrows: true,
    swipeToSlide: true,
    touchThreshold: 12,
    variableWidth: false,
    adaptiveHeight: false,
    prevArrow: `
      <button type="button" class="slick-prev slick-prev-btn" aria-label="Назад">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M22.2222 24.4446L17.7778 20.0001L22.2222 15.5557" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,
    nextArrow: `
      <button type="button" class="slick-next slick-next-btn" aria-label="Вперёд">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M17.7778 15.5554L22.2222 19.9999L17.7778 24.4443" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 6.5 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4.5 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2.5 },
      },
    ],
  });
});

$(".workshop__categories").each((_, slider) => {
  $(slider).slick({
    // Параметры настройки слайдера
    dots: false, // Показать точки навигации
    infinite: false, // Зацикливание слайдов
    speed: 500, // Скорость перехода
    variableWidth: true,
    // slidesToShow: 3.5, // Количество слайдов для показа
    slidesToScroll: 2, // Количество слайдов для прокрутки
    arrows: true,
    nextArrow: `<svg class="slick-next-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M17.7778 15.5554L22.2222 19.9999L17.7778 24.4443" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
    prevArrow: `<svg class="slick-prev-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M22.2222 24.4446L17.7778 20.0001L22.2222 15.5557" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
  });
});

function changeWorkshopStatus() {
  const workshopId = $(this).data("id");
  const userId = $("#user_id").val();
  const _token = $("input[name='_token']").val();

  const formData = new FormData();

  formData.append("status", $(this).data("status"));
  formData.append("workshop_id", workshopId);
  formData.append("user_id", userId);
  formData.append("_method", "PUT");
  formData.append("_token", _token);

  fetch(`/workshop/${workshopId}`, {
    method: "POST",
    body: formData,
  }).then(() => {
    location.reload();
  });
}

$(".publicate__workshop").on("click", changeWorkshopStatus);

$(".reject__workshop").on("click", changeWorkshopStatus);
